import React, { useState, useEffect } from 'react';
import TR from './../../Trans';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import muvikaAttrs from './../../attrs';
import Menu from '@mui/material/Menu';
import version from './../../version';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay';
import SearchIcon from '@mui/icons-material/Search';
import MenuItem from '@mui/material/MenuItem';
import { LightMode, DarkMode } from "@mui/icons-material";
import { useLocalStorage } from '../../services/useLocalStorage';
import { setSafeAreas } from './../../services/safeareas';
import Paper from '@mui/material/Paper';
import MenuIcon from '@mui/icons-material/Menu';
import ChooseLanguage from './../items/ChooseLanguage';
import navigationStore from './../../stores/navigation';
import { Views } from './../../enums/enums';
import settingsStore from '../../stores/settings';
import songbookSessionStore from './../../stores/songbookSession';
import environmentStore from '../../stores/environment';
import sessionStore from './../../stores/session';

function BottomBar() {

  const isSongbookPublicMode = songbookSessionStore((state) => state.isSongbookPublicMode);
  const isSongbookPublicBoothMode = songbookSessionStore((state) => state.isSongbookPublicBoothMode);
  const sessionToken = songbookSessionStore((state) => state.sessionToken);
  const logout = songbookSessionStore((state) => state.logout);
  const goToView = navigationStore((state) => state.goToView);
  const settings = settingsStore((state) => state.settings);
  const getSettings = settingsStore((state) => state.getSettings);
  const safeArea = navigationStore((state) => state.safeArea);
  const environment = environmentStore((state) => state.environment);
  const getEnvironment = environmentStore((state) => state.getEnvironment);
  const updateSession = songbookSessionStore((state) => state.updateSession);
  const currentView = navigationStore((state) => state.currentView);

  const [theme, setTheme] = useLocalStorage(muvikaAttrs.service + "-songbook-theme", "dark");

  const [anchorEl, setAnchorEl] = useState(null);
  const [isBottomBarMenuOpen, setBottomBarMenuOpen] = useState(false);

  const [, updateState] = useState();

  useEffect(() => {
    goToView(Views.NewTracks);
    if (!settings) {
      getSettings(sessionToken);
    }
  }, []);

  const handleBottomBarMenuClose = () => {
    setBottomBarMenuOpen(false);
  };

  const openBottomBarMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setBottomBarMenuOpen(true);
  };

  const renderPerformancesLink = () => {
    if (settings) {
      if (settings.sb_allow_playqueue_view == 1 && !isSongbookPublicMode) {
        return <BottomNavigationAction className={currentView == Views.SongbookPerformances ? "Mui-selected" : ""} label={TR.cm_playqueue} icon={<PlaylistPlayIcon />} onClick={() => goToView(Views.SongbookPerformances)} />;
      }
    }
  };

  const renderLoginMenuButton = () => {
    return <BottomNavigationAction icon={<MenuIcon />} onClick={openBottomBarMenu} />;
  };

  const renderLogoutLink = () => {
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        return <MenuItem className="muvika-bottom-bar-logout" onClick={() => {
          handleBottomBarMenuClose();
          logout();
        }}>
          {TR.cm_logout.toUpperCase()}
        </MenuItem>;
      }
    }
  };

  const handleLanguageChange = (language) => {
    let lowLang = language.toLowerCase();
    updateSession(sessionToken, lowLang);
    updateState({});
  };

  const renderVersion = () => {
    if (isSongbookPublicMode) {
      return <MenuItem className="muvika-version-number">
        <small>{version} Public mode {muvikaAttrs.side === "dev" ? "no_rep" : ""}</small>
      </MenuItem>;
    } else if (isSongbookPublicBoothMode) {
      return <MenuItem className="muvika-version-number">
        <small>{version} Booth mode {muvikaAttrs.side === "dev" ? "no_rep" : ""}</small>
      </MenuItem>;
    }
    return <MenuItem className="muvika-version-number">
      <small>{version} {muvikaAttrs.side === "dev" ? "no_rep" : ""}</small>
    </MenuItem>;
  };

  const toggleTheme = () => {
    if (theme === "light") {
      document.documentElement.classList.remove("light-theme");
      setTheme("dark");
    } else {
      document.documentElement.classList.add("light-theme");
      setTheme("light");
    }
    handleBottomBarMenuClose();
  };

  const renderThemeLink = () => {
    if (theme === "dark") {
      return <MenuItem onClick={() => toggleTheme()}>
          <ListItemIcon>
            <LightMode />
          </ListItemIcon>
          <ListItemText primary={TR.cm_set_light_theme} />
      </MenuItem>;
    } else {
      return <MenuItem onClick={() => toggleTheme()}>
          <ListItemIcon>
            <DarkMode />
          </ListItemIcon>
          <ListItemText primary={TR.cm_set_dark_theme} />
      </MenuItem>;
    }
  };

  return (
    <div id="muvika-bottom-bar">
      <Paper className="muvika-bottom-bar-paper" elevation={10} sx={{
        paddingBottom: safeArea ? safeArea.bottom + "px" : 0,
        paddingLeft: safeArea ? safeArea.left + "px" : 0,
        paddingRight: safeArea ? safeArea.right + "px" : 0
      }}>
        <BottomNavigation
          className="muvika-bottom-bar-nav"
          showLabels
        >
          <BottomNavigationAction className={currentView == Views.NewTracks ? "Mui-selected" : ""} label={TR.cm_new} icon={<FiberNewIcon />} onClick={() => goToView(Views.NewTracks)} />
          <BottomNavigationAction className={currentView == Views.Catalog ? "Mui-selected" : ""} label={TR.cm_browse} icon={<MusicNoteIcon />} onClick={() => goToView(Views.Catalog)} />
          <BottomNavigationAction className={currentView == Views.Search ? "Mui-selected" : ""} label={TR.cm_search} icon={<SearchIcon />} onClick={() => goToView(Views.Search)} />
          {renderPerformancesLink()}
          {renderLoginMenuButton()}
        </BottomNavigation>
      </Paper>
      <Menu disableAutoFocus disableEnforceFocus disableRestoreFocus
        id={"menu-bottombar"}
        className="muvika-bottom-bar-menu"
        open={isBottomBarMenuOpen}
        sx={{
          marginTop: safeArea ? (-safeArea.bottom - 38) + "px" : "-2.4rem",
          marginLeft: safeArea ? (-safeArea.right) + "px" : "-0.94rem"
        }}
        anchorEl={anchorEl}
        onClose={handleBottomBarMenuClose}
        MenuListProps={{
          'aria-labelledby': "menu-bottombar",
        }}
      >
        {renderThemeLink()}
        <ChooseLanguage isSongbook={true} environment={environment} onLanguageChange={handleLanguageChange} />
        {renderVersion()}
        {renderLogoutLink()}
      </Menu>
    </div>
  );
}

export default BottomBar;